import { useAppSelector } from "../store/hooks";
import Tile from "./Tile";
import PlayMusic from "./PlayMusic";
import song from "../assets/song.mp3";

function Board() {
  const board: string[] = useAppSelector(({ candyCrush: { board } }) => board);
  const boardSize: number = useAppSelector(
    ({ candyCrush: { boardSize } }) => boardSize
  );
  return (
    <div className="flex items-center justify-center ">
      <div className="absolute top-0 left-0 ">
        <PlayMusic url={song} />
      </div>
      <div className="flex flex-1 items-center justify-center h-screen">
        <div
          className="flex flex-wrap rounded-lg"
          style={{
            width: `${6.25 * boardSize}rem`,
          }}
        >
          {board.map((candy: string, index: number) => (
            <Tile candy={candy} key={index} candyId={index} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Board;
